var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1SafeHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.38 3.63L3 25.89V69h70V25.89L38.38 3.63zM69 65H7V28.1L38.35 8.37 69 28.08V65zM29.53 32.77V36h-3.47v19H50V36h-3.54v-3.23a8.465 8.465 0 10-16.93 0zM40.12 50H37v-9.07h3.14L40.12 50zm3.34-17.23V36H32.53v-3.23a5.465 5.465 0 0110.93 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Safe_house.6fefe4ed.svg";
export { SvgG1SafeHouse as ReactComponent };